import UserRoles from "../../Shared/Constant/UserRoles";

import {
  getMasterDataService,
  addMastersDataService,
  updateMastersDataService,
  deleteMasterDataService,
  getMasterCardsDataService,
} from "../../Services/MasterService";
import { RESET_DROPDOWN_OPTIONS } from "./DropdownMasters/DropdownMastersAction";
export const SET_ADV_SEARCH_FORM_TYPE = "SET_ADV_SEARCH_FORM_TYPE";
export const FETCH_MASTER_CARDS = "FETCH_MASTER_CARDS";
export const FETCH_MASTER_CARDS_SUCCESS = "FETCH_MASTER_CARDS_SUCCESS";
export const FETCH_MASTER_CARDS_FAILURE = "FETCH_MASTER_CARDS_FAILURE";
export const ONGOING_ADVANCE_SEARCH = "ONGOING_ADVANCE_SEARCH";

/**Added for generic master data */

export const RESET_ADDED_DATA = "RESET_ADDED_DATA";
export const FETCH_MASTER_DATA = "FETCH_MASTER_DATA";
export const FETCH_MASTER_DATA_SUCCESS = "FETCH_MASTER_DATA_SUCCESS";
export const FETCH_MASTER_DATA_FAILURE = "FETCH_MASTER_DATA_FAILURE";
export const ADD_MASTER_DATA = "ADD_MASTER_DATA";
export const ADD_MASTER_DATA_SUCCESS = "ADD_MASTER_DATA_SUCCESS";
export const ADD_MASTER_DATA_FAILURE = "ADD_MASTER_DATA_FAILURE";
export const UPDATE_MASTER_DATA = "UPDATE_MASTER_DATA";
export const UPDATE_MASTER_DATA_SUCCESS = "UPDATE_MASTER_DATA_SUCCESS";
export const UPDATE_MASTER_DATA_FAILURE = "UPDATE_MASTER_DATA_FAILURE";
export const DELETE_MASTER_DATA = "DELETE_MASTER_DATA";
export const DELETE_MASTER_DATA_SUCCESS = "DELETE_MASTER_DATA_SUCCESS";
export const DELETE_MASTER_DATA_FAILURE = "DELETE_MASTER_DATA_FAILURE";
export const SET_MASTER_ERROR = "SET_MASTER_ERROR";

export const setMasterError = (error = false) => {
  return (dispatch) => {
    dispatch({ type: SET_MASTER_ERROR, payload: error });
  };
};

export const setAdvSearchFormType = (formType) => {
  return (dispatch) => {
    dispatch({ type: SET_ADV_SEARCH_FORM_TYPE, payload: formType });
  };
};
export const setOngoingSearch = (flag) => {
  return (dispatch) => {
    dispatch({ type: ONGOING_ADVANCE_SEARCH, payload: flag });
  };
};

export const fetchMasterCardsData = (userRole = UserRoles.ADMIN) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_MASTER_CARDS });
    try {
      const cardData = await getMasterCardsDataService(userRole);
      dispatch({ type: FETCH_MASTER_CARDS_SUCCESS, payload: cardData });
    } catch (err) {
      dispatch({ type: FETCH_MASTER_CARDS_FAILURE });
    }
  };
};

// master crud actions

export const resetAddedData = () => {
  return (dispatch) => {
    dispatch({ type: RESET_ADDED_DATA });
  };
};
export const fetchMasterData = (masterType, languageId, page, pageSize, filters ) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_MASTER_DATA });
    try {
      const masterData = await getMasterDataService(masterType, languageId, page, pageSize, filters );

      dispatch({
        type: FETCH_MASTER_DATA_SUCCESS,
        payload: masterData?.data || [],
        paginationData: 
        { totalCount: masterData?.totalCount || 0, 
          page: masterData?.page || 1,
          pageSize: masterData?.pageSize || 10
        }
      });
    } catch (_error) {
      dispatch({ type: FETCH_MASTER_DATA_FAILURE });
    }
  };
};

export const addMasterData = (masterType, title, formObj, t, handleClose) => {
  return async (dispatch) => {
    dispatch({ type: ADD_MASTER_DATA });
    try {
      await addMastersDataService(masterType, title, formObj, t);
      dispatch({ type: ADD_MASTER_DATA_SUCCESS, payload: formObj });
      dispatch({ type: RESET_DROPDOWN_OPTIONS });
      handleClose();
    } catch (error) {
      dispatch({ type: ADD_MASTER_DATA_FAILURE });
    }
  };
};

export const updateMasterData = (
  masterType,
  title,
  formData,
  handleClose,
  showApproveRejectBtn,
  t
) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_MASTER_DATA });
    try {
      await updateMastersDataService(masterType, title, formData, t);
      dispatch({ type: UPDATE_MASTER_DATA_SUCCESS });
      showApproveRejectBtn && handleClose();
      dispatch({ type: RESET_DROPDOWN_OPTIONS });
    } catch (_error) {
      dispatch({ type: UPDATE_MASTER_DATA_FAILURE });
    }
  };
};

export const deleteMasterData = (
  masterType,
  title,
  selectedId,
  selectedName,
  handleDeleteClose,
  t
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DELETE_MASTER_DATA });
      const response = await deleteMasterDataService(
        masterType,
        title,
        selectedId,
        selectedName,
        t
      );
      handleDeleteClose();
      dispatch({ type: DELETE_MASTER_DATA_SUCCESS, payload: response });
    } catch (error) {
      dispatch({ type: DELETE_MASTER_DATA_FAILURE, payload: error });
    }
  };
};
